import React from "react";
import { Card, Typography, Space, Tag, Button, Popconfirm } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  ReadOutlined,
  BookOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

export const PrimarySchoolCard = ({ school, onDelete, onEdit }) => (
  <Card
    title={
      <Space>
        <ReadOutlined /> <span>{school.schoolType.description}</span>
      </Space>
    }
    extra={
      <Space>
        <Button
          icon={<EditOutlined />}
          onClick={() => {
            onEdit("PRIMARY_SCHOOL", school);
          }}
          size="small">
          Düzenle
        </Button>
        <Popconfirm
          title="Eğitim Bilgisini Sil"
          description="Bu eğitim bilgisini silmek istediğinize emin misiniz?"
          onConfirm={() => onDelete(school.id)}
          okText="Evet"
          cancelText="Hayır">
          <Button icon={<DeleteOutlined />} size="small" danger>
            Sil
          </Button>
        </Popconfirm>
      </Space>
    }
    style={{ marginBottom: 10 }}>
    <Title style={{ margin: 0 }} level={4}>
      {school.schoolName}
    </Title>
    <Text>
      Mezuniyet Durumu:{" "}
      {school.completionStatus
        ? school.completionStatus.description
        : "Devam Ediyor"}
    </Text>
    <br />
    <Text>
      Eğitim Dönemi: {`${school.startMonth}/${school.startYear}`} -{" "}
      {school.completionStatus === null
        ? "Devam Ediyor"
        : `${school.endMonth}/${school.endYear}`}
    </Text>
  </Card>
);

export const HighSchoolCard = ({ school, onDelete, onEdit }) => (
  <Card
    title={
      <Space>
        <BookOutlined /> <span>{school.schoolType.description}</span>
      </Space>
    }
    extra={
      <Space>
        <Button
          icon={<EditOutlined />}
          onClick={() => {
            onEdit("HIGH_SCHOOL", school);
          }}
          size="small">
          Düzenle
        </Button>
        <Popconfirm
          title="Eğitim Bilgisini Sil"
          description="Bu eğitim bilgisini silmek istediğinize emin misiniz?"
          onConfirm={() => onDelete(school.id)}
          okText="Evet"
          cancelText="Hayır">
          <Button icon={<DeleteOutlined />} size="small" danger>
            Sil
          </Button>
        </Popconfirm>
      </Space>
    }
    style={{ marginBottom: 16 }}>
    <Title style={{ margin: 0 }} level={4}>
      {school.schoolName}
    </Title>
    <Text>
      Mezuniyet Durumu:{" "}
      {school.completionStatus
        ? school.completionStatus.description
        : "Devam Ediyor"}
    </Text>
    <br />
    <Text>
      Eğitim Dönemi: {`${school.startMonth}/${school.startYear}`} -{" "}
      {school.completionStatus === null
        ? "Devam Ediyor"
        : `${school.endMonth}/${school.endYear}`}
    </Text>
    <br />
    <Text>Eğitim Dili: {school.educationLanguage.name}</Text>
    <br />
    <Text>Ek Bilgiler: {school.description}</Text>
  </Card>
);

export const UniversityCard = ({ school, onDelete, onEdit }) => (
  <Card
    title={
      <Space>
        <SafetyCertificateOutlined />{" "}
        <span>{school.schoolType.description}</span>
      </Space>
    }
    extra={
      <Space>
        <Button
          icon={<EditOutlined />}
          onClick={() => {
            onEdit("UNIVERSITY", school);
          }}
          size="small">
          Düzenle
        </Button>
        <Popconfirm
          title="Eğitim Bilgisini Sil"
          description="Bu eğitim bilgisini silmek istediğinize emin misiniz?"
          onConfirm={() => onDelete(school.id)}
          okText="Evet"
          cancelText="Hayır">
          <Button icon={<DeleteOutlined />} size="small" danger>
            Sil
          </Button>
        </Popconfirm>
      </Space>
    }
    style={{ marginBottom: 16 }}>
    <Title style={{ margin: 0 }} level={4}>
      {school.schoolName}
    </Title>
    <Text>
      Mezuniyet Durumu:{" "}
      {school.completionStatus
        ? school.completionStatus.description
        : "Devam Ediyor"}
    </Text>
    <br />
    <Text>
      Eğitim Dönemi: {`${school.startMonth}/${school.startYear}`} -{" "}
      {school.completionStatus === null
        ? "Devam Ediyor"
        : `${school.endMonth}/${school.endYear}`}
    </Text>
    <br />
    <Text>Eğitim Tipi: {school.educationType.description}</Text>
    <br />
    <Text>Fakülte: {school.faculty}</Text>
    <br />
    <Text>Bölüm: {school.department}</Text>
    <br />
    <Text>Not Ortalaması: {school.gpa}</Text>
    <br />
    <Text>Eğitim Dili: {school.educationLanguage.name}</Text>
    <br />
    <Text>Ek Bilgiler: {school.description}</Text>
    <br />
  </Card>
);
